import truncate from 'lodash-es/truncate';
import * as homeUrls from 'mk2/apps/home/urls';
import { ArticleEntity, WikiCategoryEntity } from 'mk2/apps/wiki/schemas';
import { isCategoryArticle, poormanPlaintext, wikiArticleUrl, wikiCategoryUrl } from 'mk2/apps/wiki/utils';
import { mainImageUrlWithFallback, organizationModrykonik } from 'mk2/helpers/structuredData';
import { YMDHMSIso } from 'mk2/helpers/timeformat';
import { ACTIVE_SERVER_URL, fbMorykonikProfileUrl } from 'mk2/helpers/urls';

const breadcrumbCategory = (baseUrl: string, category: WikiCategoryEntity) => ({
    '@type': 'ListItem',
    'position': 1,
    'item': {
        '@id': baseUrl + wikiCategoryUrl(category),
        'name': category.name,
    },
});

const breadcrumbArticle = (baseUrl: string, article: ArticleEntity) => ({
    '@type': 'ListItem',
    'position': 2,
    'item': {
        '@id': baseUrl + wikiArticleUrl(article),
        'name': article.title,
    },
});

export function breadcrumbsWiki(baseUrl, article: ArticleEntity) {
    const items = [];

    items.push(breadcrumbCategory(baseUrl, article.category));

    if (!isCategoryArticle(article)) {
        items.push(breadcrumbArticle(baseUrl, article));
    }

    return {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': items,
    };
}

export function articleWiki(baseUrl: string, article: ArticleEntity) {
    const createdOn: string = YMDHMSIso(article.createdAt);
    const modifiedOn: string = YMDHMSIso(article.modifiedAt);
    const articleUrl = wikiArticleUrl(article);

    // according to https://developers.google.com/search/docs/data-types/article#amp
    return {
        '@context': 'http://schema.org',
        '@type': 'Article',
        '@id': baseUrl + articleUrl,
        'headline': article.title,
        // FIXME caka na json-markdown aby sme ako description poslali iba plaintext z prveho odstavca
        'description': truncate(poormanPlaintext(article.text), {length: 300, separator: ' ' }),
        'image': mainImageUrlWithFallback(article.photos), // all wiki images have version s1600x1600
        'datePublished': createdOn,
        'dateModified': modifiedOn ? modifiedOn : createdOn,
        'author': organizationModrykonik(false),
        'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': baseUrl + articleUrl,
        },
        'publisher': organizationModrykonik(false),
    };
}

export function articleWikiOG(baseUrl: string, article: ArticleEntity) {
    const createdOn: string = YMDHMSIso(article.createdAt);
    const modifiedOn: string = YMDHMSIso(article.modifiedAt);
    const articleUrl = wikiArticleUrl(article);

    // according to https://developers.facebook.com/docs/reference/opengraph/object-type/article/
    return {
        'og:type': 'article',
        'og:title': article.title,
        // FIXME caka na json-markdown aby sme ako description poslali iba plaintext z prveho odstavca
        'og:description': truncate(poormanPlaintext(article.text), {length: 300, separator: ' ' }),
        'og:image': mainImageUrlWithFallback(article.photos),
        'og:url': baseUrl + articleUrl,

        'article:author': fbMorykonikProfileUrl(),
        'article:content_tier': 'free',
        'article:published_time': createdOn,
        'article:modified_time': modifiedOn ? modifiedOn : createdOn,
        'article:publisher': ACTIVE_SERVER_URL + homeUrls.homepage,
    };
}
